import { getGenApiData, getReportApiData } from "./auth";
import { store } from "store/store";

export const authorizedGenApiCall = async (params) => {
  const { sessionGuid, userId, token } = store.getState()?.auth;

  const res = await getGenApiData({
    userId,
    sessionGuid,
    token,
    data: params?.data,
    dataKey: params?.dataKey,
    parameters: JSON.stringify(params?.parameters),
  });

  return res;
};

export const authorizedReportApiCall = async (params) => {
  const { sessionGuid, userId, token } = store.getState()?.auth;

  const res = await getReportApiData(
    {
      userId,
      sessionGuid,
      token,
      data: params?.data,
      parameters: JSON.stringify(params),
    },
    { responseType: "blob" }
  );

  return res;
};
